(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-legal-guarantee"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (!window.customElements || customElements.get('nt-eu-guarantee')) return;
  const syncScrollLock = () => {
    document.documentElement.classList.toggle('nt-eu-guarantee-open', Boolean(document.querySelector('dialog.nt-eu-guarantee__dialog[open]')));
  };
  class NtEuGuarantee extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.pointers = new Map();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => this.handleClick(event), options);
      this.addEventListener('keydown', event => this.handleEscape(event), options);
      this.addEventListener('keyup', event => this.handleEscape(event), options);
      this.addEventListener('close', () => this.handleClose(), { ...options, capture: true });
      const viewport = this.querySelector('.nt-eu-guarantee__artwork-viewport');
      if (viewport && window.PointerEvent) {
        viewport.addEventListener('pointerdown', event => this.startPointer(event), options);
        viewport.addEventListener('pointermove', event => this.movePointer(event), options);
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => {
          viewport.addEventListener(type, event => this.endPointer(event), options);
        });
      }
      window.addEventListener('resize', () => {
        const dialog = this.querySelector('dialog');
        if (!dialog || !dialog.open) return;
        if (this.getClientRects().length === 0) {
          dialog.close();
        } else if (this.viewWidth !== window.innerWidth) {
          this.setView(this.isCompact() ? 'overview' : 'read');
        }
      }, options);
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-nt-eu-open]');
        if (dialog && trigger && typeof dialog.showModal === 'function') {
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', dialog.id);
          const newWindow = trigger.querySelector('[data-nt-eu-new-window]');
          if (newWindow) newWindow.hidden = true;
          const zoomButton = this.querySelector('[data-nt-eu-zoom]');
          if (zoomButton) zoomButton.hidden = false;
        }
      });
    }
    disconnectedCallback() {
      this.resetPointers();
      if (this.controller) this.controller.abort();
      this.controller = null;
      const dialog = this.querySelector('dialog');
      if (dialog && dialog.open && typeof dialog.close === 'function') dialog.close();
      syncScrollLock();
    }
    handleEscape(event) {
      if (event.key !== 'Escape') return;
      const dialog = this.querySelector('dialog');
      if (event.type === 'keydown' && dialog && dialog.open) {
        this.escapeKeyDown = true;
        event.stopPropagation();
      } else if (event.type === 'keyup' && ((dialog && dialog.open) || this.escapeKeyDown)) {
        this.escapeKeyDown = false;
        event.stopPropagation();
      }
    }
    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const dialog = this.querySelector('dialog');
      if (!dialog) return;
      if (event.target.closest('.nt-eu-guarantee__artwork-link') && event.detail !== 0 && Date.now() < this.suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      const zoomButton = event.target.closest('[data-nt-eu-zoom]');
      if (zoomButton && dialog.contains(zoomButton)) {
        event.preventDefault();
        event.stopPropagation();
        this.setView(this.dataset.ntEuMode === 'overview' ? 'read' : 'overview');
        return;
      }
      const trigger = event.target.closest('[data-nt-eu-open]');
      if (trigger && this.contains(trigger)) {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (typeof dialog.showModal !== 'function') return;
        try {
          if (!dialog.open) dialog.showModal();
        } catch (_error) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.trigger = trigger;
        this.suppressClickUntil = 0;
        this.setView(this.isCompact() ? 'overview' : 'read');
        syncScrollLock();
        return;
      }
      if (event.target.closest('[data-nt-eu-close]')) {
        event.preventDefault();
        event.stopPropagation();
        dialog.close();
        return;
      }
      if (event.target === dialog && dialog.open) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    }
    setView(mode) {
      if (mode !== 'read' && mode !== 'overview') return;
      this.resetPointers();
      this.viewWidth = window.innerWidth;
      const scrollArea = this.querySelector('.nt-eu-guarantee__scroll');
      const viewport = this.querySelector('.nt-eu-guarantee__artwork-viewport');
      delete this.dataset.ntEuZoomable;
      this.style.removeProperty('--nt-eu-artwork-width');
      this.style.removeProperty('--nt-eu-viewport-height');
      this.updateZoomButton(mode);
      if (scrollArea) { scrollArea.scrollTop = 0; scrollArea.scrollLeft = 0; }
      if (!viewport) return;
      viewport.scrollLeft = 0;
      viewport.scrollTop = 0;
      if (this.isCompact() && window.PointerEvent && scrollArea) {
        const padding = getComputedStyle(scrollArea);
        const availableHeight = scrollArea.clientHeight - parseFloat(padding.paddingTop) - parseFloat(padding.paddingBottom);
        this.baseWidth = Math.min(794, viewport.clientWidth, Math.max(1, availableHeight) * 794 / 1123);
        if (this.baseWidth <= 0) return;
        this.dataset.ntEuZoomable = '';
        this.style.setProperty('--nt-eu-viewport-height', `${this.baseWidth * 1123 / 794}px`);
        this.applyZoom(mode === 'overview' ? 1 : Math.max(2, 794 / this.baseWidth));
      }
    }
    isCompact() {
      return window.matchMedia('(max-width: 869px)').matches;
    }
    updateZoomButton(mode) {
      this.dataset.ntEuMode = mode;
      const zoomButton = this.querySelector('[data-nt-eu-zoom]');
      if (zoomButton) {
        const label = mode === 'overview' ? zoomButton.dataset.zoomInLabel : zoomButton.dataset.zoomOutLabel;
        zoomButton.setAttribute('aria-label', label);
        zoomButton.setAttribute('title', label);
      }
    }
    applyZoom(scale, anchor) {
      const viewport = this.querySelector('.nt-eu-guarantee__artwork-viewport');
      if (!viewport || !this.baseWidth) return;
      this.scale = Math.max(1, Math.min(6, scale));
      const width = this.baseWidth * this.scale;
      this.style.setProperty('--nt-eu-artwork-width', `${width}px`);
      this.updateZoomButton(this.scale <= 1.001 ? 'overview' : 'read');
      if (anchor) {
        const inset = Math.max(0, (viewport.clientWidth - width) / 2);
        viewport.scrollLeft = inset + anchor.x * width - anchor.clientX;
        viewport.scrollTop = anchor.y * width * 1123 / 794 - anchor.clientY;
      }
      if (this.scale === 1) { viewport.scrollLeft = 0; viewport.scrollTop = 0; }
    }
    startPointer(event) {
      if (!this.hasAttribute('data-nt-eu-zoomable') || (event.pointerType === 'mouse' && event.button !== 0)) return;
      if (this.pointers.size === 0) this.gestureMoved = false;
      this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY, target: event.target });
      // Capture on the original link/image so an ordinary tap still follows its link.
      if (typeof event.target.setPointerCapture === 'function') event.target.setPointerCapture(event.pointerId);
      this.beginGesture();
    }
    beginGesture() {
      const points = [...this.pointers.values()];
      if (!points.length) { this.gesture = null; return; }
      const viewport = this.querySelector('.nt-eu-guarantee__artwork-viewport');
      const scrollArea = this.querySelector('.nt-eu-guarantee__scroll');
      this.gesture = { x: points[0].x, y: points[0].y, left: viewport.scrollLeft, top: viewport.scrollTop, outerTop: scrollArea.scrollTop };
      if (points.length < 2) return;
      const x = (points[0].x + points[1].x) / 2;
      const y = (points[0].y + points[1].y) / 2;
      const image = this.querySelector('.nt-eu-guarantee__artwork-link').getBoundingClientRect();
      Object.assign(this.gesture, {
        distance: Math.max(1, Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y)),
        scale: this.scale, anchorX: (x - image.left) / image.width, anchorY: (y - image.top) / image.height
      });
      this.gestureMoved = true;
    }
    movePointer(event) {
      const pointer = this.pointers.get(event.pointerId);
      if (!pointer || !this.gesture) return;
      pointer.x = event.clientX;
      pointer.y = event.clientY;
      const points = [...this.pointers.values()];
      const viewport = this.querySelector('.nt-eu-guarantee__artwork-viewport');
      const gesture = this.gesture;
      if (points.length >= 2) {
        const rect = viewport.getBoundingClientRect();
        const distance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
        this.applyZoom(gesture.scale * distance / gesture.distance, {
          x: gesture.anchorX, y: gesture.anchorY,
          clientX: (points[0].x + points[1].x) / 2 - rect.left,
          clientY: (points[0].y + points[1].y) / 2 - rect.top
        });
      } else {
        const dx = pointer.x - gesture.x;
        const dy = pointer.y - gesture.y;
        if (!this.gestureMoved && Math.hypot(dx, dy) < 5) return;
        this.gestureMoved = true;
        if (this.scale > 1.001) {
          viewport.scrollLeft = gesture.left - dx;
          viewport.scrollTop = gesture.top - dy;
        } else {
          // Keep the text below the image reachable with a one-finger swipe.
          this.querySelector('.nt-eu-guarantee__scroll').scrollTop = gesture.outerTop - dy;
        }
      }
      if (event.cancelable) event.preventDefault();
    }
    endPointer(event) {
      const pointer = this.pointers.get(event.pointerId);
      if (!pointer) return;
      this.pointers.delete(event.pointerId);
      if (this.gestureMoved) this.suppressClickUntil = Date.now() + 600;
      if (pointer.target.hasPointerCapture && pointer.target.hasPointerCapture(event.pointerId)) pointer.target.releasePointerCapture(event.pointerId);
      this.beginGesture();
    }
    resetPointers() {
      if (!this.pointers) return;
      const pointers = [...this.pointers.entries()];
      this.pointers.clear();
      this.gesture = null;
      pointers.forEach(([id, pointer]) => {
        if (pointer.target.hasPointerCapture && pointer.target.hasPointerCapture(id)) pointer.target.releasePointerCapture(id);
      });
    }
    handleClose() {
      this.resetPointers();
      syncScrollLock();
      if (this.trigger && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
    }
  }
  customElements.define('nt-eu-guarantee', NtEuGuarantee);
})();
  } catch(e) { console.error(e); }
})();

})();
